import { ISurveyQuestionItem } from "../common/data/dtos/survey-question-item";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/SurveyQuestionItem';

interface SurveyQuestionItemResponse {
    success: boolean;
    surveyQuestionItem?: ISurveyQuestionItem;
    surveyQuestionItems?: ISurveyQuestionItem[];
    error?: string;
}

type CreateSurveyQuestionItemType = Omit<ISurveyQuestionItem, 'id'> | Partial<ISurveyQuestionItem>;

const createSurveyQuestionItem = async (surveyQuestionItem: CreateSurveyQuestionItemType): Promise<SurveyQuestionItemResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ISurveyQuestionItem>(`${BASE_PATH}`, surveyQuestionItem);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const createManySurveyQuestionItem = async (surveyQuestionItems: CreateSurveyQuestionItemType[]): Promise<SurveyQuestionItemResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ISurveyQuestionItem>(`${BASE_PATH}`, surveyQuestionItems);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteSurveyQuestionItem = async (id: string): Promise<SurveyQuestionItemResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<ISurveyQuestionItem>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getSurveyQuestionItems = async (): Promise<SurveyQuestionItemResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyQuestionItem>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyQuestionItems: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOneSurveyQuestionItem = async (id: string): Promise<SurveyQuestionItemResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyQuestionItem>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyQuestionItem: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateSurveyQuestionItem = async (surveyQuestionItem: ISurveyQuestionItem): Promise<SurveyQuestionItemResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<ISurveyQuestionItem>(`${BASE_PATH}/${surveyQuestionItem.id}`, surveyQuestionItem);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getSurveyQuestionItemBySurveyQuestion = async (id: string): Promise<SurveyQuestionItemResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyQuestionItem>(`${BASE_PATH}/GetBySurveyQuestion?id=${id}`);
        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyQuestionItems: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createSurveyQuestionItem,
    createManySurveyQuestionItem,
    deleteSurveyQuestionItem,
    getSurveyQuestionItems,
    getOneSurveyQuestionItem,
    updateSurveyQuestionItem,
    getSurveyQuestionItemBySurveyQuestion
};